import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ChoosePinView from "./view";
import { useSingleFlag } from "@/hooks/useFlags";
import { ReducersTypes } from "@/redux/reducers/Models";

export default function ChoosePin() {
  const navigate = useNavigate();
  const customer = useSelector((state: ReducersTypes) => state.customerReducer);
  const user = useSelector((state: ReducersTypes) => state.userReducer);

  const isAvulsoFlow =
    !customer?.register?.document &&
    user?.plate &&
    (user?.name || user?.email || user?.phone);

  // Feature flags Avulso
  const { isEnabled: showAvulsoSms, isLoading: isLoadingAvulsoSms } =
    useSingleFlag("PD_PIN_AVULSO_SMS");
  const { isEnabled: showAvulsoWhatsApp, isLoading: isLoadingAvulsoWhatsApp } =
    useSingleFlag("PD_PIN_AVULSO_WHATSAPP");
  const { isEnabled: showAvulsoEmail, isLoading: isLoadingAvulsoEmail } =
    useSingleFlag("PD_PIN_AVULSO_EMAIL");

  // Feature flags Onboarding
  const { isEnabled: showOnboardingSms, isLoading: isLoadingOnboardingSms } =
    useSingleFlag("PD_PIN_ONBOARDING_SMS");
  const {
    isEnabled: showOnboardingEmail,
    isLoading: isLoadingOnboardingEmail,
  } = useSingleFlag("PD_PIN_ONBOARDING_EMAIL");

  const showSms = isAvulsoFlow ? showAvulsoSms : showOnboardingSms;
  const showWhatsApp = isAvulsoFlow ? showAvulsoWhatsApp : false;
  const showEmail = isAvulsoFlow ? showAvulsoEmail : showOnboardingEmail;

  const isLoadingFlags = isAvulsoFlow
    ? isLoadingAvulsoSms || isLoadingAvulsoWhatsApp || isLoadingAvulsoEmail
    : isLoadingOnboardingSms || isLoadingOnboardingEmail;

  const goBack = () => navigate(-1);

  const goToPin = (type: "email" | "phone" | "whatsapp") => {
    navigate("/register/pin/" + type);
  };

  return (
    <ChoosePinView
      goBack={goBack}
      goToPin={goToPin}
      showSms={showSms}
      showWhatsApp={showWhatsApp}
      showEmail={showEmail}
      isLoadingFlags={isLoadingFlags}
    />
  );
}
